import { render, staticRenderFns } from "./GuideMore.vue?vue&type=template&id=247db556&scoped=true&"
import script from "./GuideMore.vue?vue&type=script&lang=js&"
export * from "./GuideMore.vue?vue&type=script&lang=js&"
import style0 from "./GuideMore.vue?vue&type=style&index=0&id=247db556&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247db556",
  null
  
)

export default component.exports